var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative"},[_c('BusinessBody')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }